<!-- tool-tip component -->
<div class="tool-tip" *ngIf="this.pageContent.displayText">
    <svg 
        width="20" height="20" 
        (click)="this.onClick()" 
        (keydown.enter)="this.onClick()"
        (keydown.Space)="this.onClick()" 
        tabindex="0"
    >
        <circle cx="10" cy="10" r="9" stroke="black" stroke-width="1" fill="white" />
        <text x="10" y="14" font-size="12" text-anchor="middle">?</text>
    </svg>  
    <div 
        class="tool-tip-container {{this.isOpen ? 'open' : 'close'}}"
        #tooltipContainer
    >
        <div class="cross">
            <a 
                (click)="this.onClick()" 
                (keydown.enter)="this.onClick()" 
                (keydown.Space)="this.onClick()"
                tabindex="{{this.isOpen ? '0' : '-1'}}"
            >
                X
            </a>
        </div>
        <div class="tip-text">
            <h2>Now Tip:</h2>
            <span [innerHTML]="pageContent.displayText">
            </span>
        </div>
        <div class="tip-rating">
            <span><strong>Was this helpful?</strong></span>
            <div class="thumbs">
                <div kendoRippleContainer class="kendo-ripple-container-custom k-ripple-container">
                    <button kendoButton tabindex="-1" class="kendo-button-custom k-button k-button-md k-rounded-md k-button-solid-base k-button-solid" (click)="upVote()">
                        <img alt="upvote tool-tip" src="../../../assets/images/Upvote.svg" height="65" width="50" />
                    </button>
                </div>
                <div kendoRippleContainer class="kendo-ripple-container-custom k-ripple-container">
                    <button kendoButton tabindex="-1" class="kendo-button-custom k-button k-button-md k-rounded-md k-button-solid-base k-button-solid" (click)="downVote()">
                        <img alt="downvote tool-tip" src="../../../assets/images/Downvote.svg" height="65" width="50" />
                    </button>
                </div>
            </div>
            <span *ngIf="this.hasUpvoted || this.hasDownvoted">Thank you for your feedback!</span>
        </div>
    </div>
</div>